import Sidemenu from '../components/base/sidemenu';
import Admin from '../components/admin/admin';

export default function DashboardPage() {
    return (
        <div className='flex'>
            <Sidemenu />
            <Admin />
        </div>
    );
}
